import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { LocalStorageService } from '@ndk/ng-storage';

import { LocalStorageKeys } from '@core/storage/local-storage.enum';

import { IAuthToken } from './shared/auth-token.model';
import { RoleTypes } from './shared/role-types.enum';

@Injectable()
export class AuthTokenService {
    private jwtHelper: JwtHelperService = new JwtHelperService();
    private lsToken: IAuthToken;

    constructor(private localStorage: LocalStorageService) { }

    public get encodedToken(): string {
        return this.localStorage.getValue(LocalStorageKeys.Token);
    }

    public get token(): IAuthToken {
        if (!this.lsToken) {
            const t: string = this.localStorage.getValue(LocalStorageKeys.Token);

            if (t) {
                this.lsToken = this.jwtHelper.decodeToken(t);
            }
        }

        return this.lsToken || <IAuthToken>{};
    }

    public get role(): RoleTypes {
        return +this.token.rol;
    }

    public get isUserManager(): boolean {
        // tslint:disable-next-line:no-bitwise
        return this.role & RoleTypes.User && this.token.mngr === 'true';
    }

    public get isLocalVersion(): boolean {
        return this.token.lcl === 'true';
    }

    public get enabledPoliciesLicense(): boolean {
        return this.token.lcl === 'true' ? this.token.licp === 'true' : true;
    }

    public createToken(value: string): void {
        this.localStorage.setValue(LocalStorageKeys.Token, value);
        this.lsToken = this.jwtHelper.decodeToken(value);
    }

    public resetToken(): void {
        this.lsToken = null;
        this.localStorage.deleteValue(LocalStorageKeys.Token);
    }
}
